<template>
  <div class="tags-container">
    <div class="others">
      <div class="container_media">
        <div class="tag-row">
          <div class="title">场景：</div>
          <div class="tags-wrap">
            <span :class="{ active_label: !labelIds }" @click="setActiv(null, null)">全部</span>
            <span
              v-for="(o, i) in labelList"
              :key="`scene_${o.label_id}`"
              :class="{ active_label: o.label_id == labelIds }"
              @click="setActiv(o, i)"
            >{{ o.label_name }}</span>
          </div>
        </div>
        <div class="tag-row" v-if="labelIds">
          <div class="title">类型：</div>
          <div class="tags-wrap">
            <span :class="{ active_label: !labelChilIds }" @click="setActivChild(null)">全部</span>
            <span
              v-for="(o, i) in labelChild"
              :key="`type_${o.label_id}_${i}`"
              :class="{ active_label: o.label_id == labelChilIds }"
              @click="setActivChild(o)"
            >{{ o.name }}</span>
          </div>
        </div>
        <div class="tag-sort-box">
          <div class="tag_sort">
            <div class="tag_sort_title">排序方式：</div>
            <div class="tag_sort_content">
              <span
                v-for="(item, index) in orderList"
                :key="index"
                :class="{ active_label: item.value == orderNo }"
                @click="setOrder(item)"
              >{{ item.label }}</span>
            </div>
          </div>
          <div class="tag-pagina">
            <i class="pagina_l el-icon-arrow-left" :class="{ active: lpage }" @click="prevPage"></i>
            <span class="pager">
              <i class="page">{{ pager.page }}</i>
              <i class="pagesize">/{{ pages || '...' }}</i>
            </span>
            <i class="pagina_r el-icon-arrow-right" :class="{ active: rpage }" @click="nextPage"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSoundLabel } from '@/api/soundEffect'
import { orderList } from '@/config'

export default {
  name: 'SearchSoundTagsFilter',
  props: {
    pager: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      labelList: [],
      labelIds: '',
      labelChilIds: '',
      labelIdx: null,
      orderList,
      orderNo: '',
      lpage: false,
      rpage: false
    }
  },
  computed: {
    pages() {
      if (!this.pager.limit) return 0
      return Math.ceil(this.pager.total / this.pager.limit)
    },
    labelChild() {
      if (!this.labelIds) {
        return (this.labelList && this.labelList[0] && this.labelList[0].son) || []
      }
      return (this.labelList && this.labelList[this.labelIdx] && this.labelList[this.labelIdx].son) || []
    }
  },
  created() {
    this.getLabel()
  },
  methods: {
    async getLabel() {
      try {
        const { data } = await getSoundLabel()
        this.labelList = data || []
      } catch (e) {
        console.error(e)
      }
    },
    buildLabelId() {
      let label_id = ''
      if (this.labelIds && !this.labelChilIds) {
        const sons = (this.labelList[this.labelIdx] && this.labelList[this.labelIdx].son) || []
        label_id = sons.map((item) => item.label_id).filter(Boolean).join(',')
      } else if (this.labelIds && this.labelChilIds) {
        label_id = String(this.labelChilIds)
      } else if (!this.labelIds && this.labelChilIds) {
        label_id = String(this.labelChilIds)
      }
      return label_id
    },
    emitChange() {
      this.$emit('change', {
        label_id: this.buildLabelId(),
        order: this.orderNo
      })
    },
    setActiv(item, index) {
      if (item) {
        this.labelIds = item.label_id
        this.labelIdx = index
      } else {
        this.labelIds = ''
        this.labelIdx = null
      }
      this.labelChilIds = ''
      this.emitChange()
    },
    setActivChild(item) {
      this.labelChilIds = item ? item.label_id : ''
      this.emitChange()
    },
    setOrder(item) {
      this.orderNo = item.value
      this.emitChange()
    },
    prevPage() {
      if (this.pager.page < 2) return
      this.$emit('pageChange', { page: this.pager.page - 1 })
      this.lpage = true
      this.rpage = false
    },
    nextPage() {
      if (this.pager.page < this.pages) {
        this.$emit('pageChange', { page: this.pager.page + 1 })
        this.lpage = false
        this.rpage = true
      }
    },
    cleanTagSearch() {
      this.labelIds = ''
      this.labelChilIds = ''
      this.labelIdx = null
      this.orderNo = ''
      this.emitChange()
    }
  }
}
</script>

<style lang="scss" scoped>
@import './tags-filter-shell.scss';
</style>
